import { EntityList } from '@vromo/models';
import { CourierInfo } from '@vromo/models/CourierInfo';
import { makeObservable, observable } from 'mobx';

export interface CourierInfoListItem {
    id: number;
    jobStatus: string;
    courierInfo: EntityList<CourierInfo> | null;
    driverName: string | null;
}
[];

export class CourierInfoStore {
    courierInfoList = [];

    constructor() {
        makeObservable(this, {
            courierInfoList: observable
        });
    }
}

export const courierInfoStore = new CourierInfoStore();
